import { jsx } from "react/jsx-runtime";
import "react";
import { Tab } from "@mui/material";
function Tab_Tab({ sx, children, ...props }) {
    return /*#__PURE__*/ jsx(Tab, {
        sx: sx,
        label: children,
        ...props
    });
}
export { Tab_Tab as Tab };

//# sourceMappingURL=Tab.js.map